import mixpanel from 'mixpanel-browser';
import { APP_CONFIG } from '@/constants/config';

const MIXPANEL_TOKEN = APP_CONFIG.MIXPANEL_TOKEN;

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn('Mixpanel token missing');
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    debug: import.meta.env.DEV,
    track_pageview: false,
    persistence: 'localStorage',
    record_sessions_percent: 100,
    record_heatmap_data: true,
  });

  // Clear any opt-out flag persisted from before excludeFromAnalytics stopped
  // blocking tracking outright — otherwise previously-excluded browsers stay
  // silently opted out forever, even though nothing calls opt_out anymore.
  if (mixpanel.has_opted_out_tracking?.()) {
    mixpanel.opt_in_tracking();
  }
};

export const trackEvent = (event, properties = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.track(event, properties);
};

export const setTrackingContext = (properties = {}) => {
  if (!MIXPANEL_TOKEN) return;
  const toSet = {};
  for (const [key, value] of Object.entries(properties)) {
    if (value == null) {
      mixpanel.unregister(key);
    } else {
      toSet[key] = value;
    }
  }
  if (Object.keys(toSet).length > 0) {
    mixpanel.register(toSet);
  }
};

export const identifyUser = (userId, properties = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.identify(String(userId));
  mixpanel.people.set(properties);
};

export const resetAnalyticsUser = () => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.reset();
};
